import React from 'react';

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetList from '../../widget/WidgetList';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetNotification from '../../widget/WidgetNotification';

import './chat.scss'

const sourcePath =  Config.getSourcePath();

class ChatHistory extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            basePath: Config.getBasePath(),
            data:undefined,
            page:1,
            total: 0,
            loading:true,
            options: {
                delete: true,
                transform: true,
                records: 10
            }
        }
    }

    componentDidMount()
    {
        this.loadData();
    }

    loadData = () => {

        const { basePath, options, page } = this.state;

        const { scene } = this.props;

        this.setState({loading:true});

        const onLoadData = (res, params ) => {

            if( res.status===0 )
            {
                let data = [];
                if( res.results && res.results.length )
                {
                    for(let item of res.results)
                    {
                        item["key"] = item.id;

                        data.push({...item});
                    }
                   
                }
                this.setState({data:data, total:res.total, loading:false});
            }
        }

        let params = {
            scene:scene,
            type:"02",
            page:page,
            records: options.records
        }

        WidgetAjax.ajax({url: basePath + "/session/list", params:params, callback:onLoadData}, this.props);

    }

    notify = (item, type) => {

        switch( type )
        {
            case "title":
            {
                let data = JSON.stringify(item);
                
                return (
                    <div className="sf-list-title">
                        <div className="click" onClick={() => { this.click(data, "click")}}>{item.title}</div>
                        <div className="sg-time">{item.creating_time}</div>
                    </div>
                )
                break;
            }
            case "delete":
            {
                this.deleteSession(item);
                break;
            }
        }
    }

    click= (item, type) => {

        let data = item;

        if( item )
        {
            data = JSON.parse(item);
        }

        if( this.props.notify )
        {
            this.props.notify(data, "history-click")
        }
    }

    deleteSession =( item ) => {

        WidgetNotification.customWarning({
            title: '删除会话', notificationContent: `确认要删除这个会话吗？`, comfirmFun: () => {
                this.handleRemoveSession(item);
            }
        })
    }

    handleRemoveSession = ( item ) => {

        const { basePath, options, page } = this.state;

        this.setState({loading:true});

        const onHandleRemoveSession = (res, params ) => {

            if( res.status===0 )
            {
                WidgetMessage.success("会话删除成功！");

                this.loadData();
            }
            else
            {
                WidgetMessage.error("会话删除失败：" + res.message);
            }
        }

        let params = {
            id: item.id
        }

        WidgetAjax.ajax({url: basePath + "/session/remove", params:params, callback:onHandleRemoveSession}, this.props);

    }

    pageTurning = (page, pageSize) => {

        let {options} = this.state;

        options["records"] = pageSize;

        this.setState({page:page, options:options}, () => {
            this.loadData();
        })
    }


    render()
    {
        const { options, page, total, data, loading} = this.state;

        return (
            <div className="sf-chat-history">
                <WidgetList options={options} 
                    page={page}
                    total={total}
                    data={data}
                    notify={this.notify}
                    loading={loading}
                    pageTurning={this.pageTurning}
                ></WidgetList>
            </div>
        )

    }
}

export default ChatHistory